import { useContext } from 'react';
import { NotificationsContext } from '../contexts/NotificationsContext';

const useNotifications = () => useContext(NotificationsContext);

export default useNotifications;
